import { observer } from 'mobx-react-lite';
import {
  convertAmount,
  formatDate,
  getAmountWithCurrency,
  ListBoxItemImg,
  ListItemBox,
  ListItemBoxCell,
  ListItemBoxText,
  ListItemCont,
  ListItemBoxRow,
  ListElemText,
  ListItemBoxHeader,
  PopupTypes,
  useTranslation,
  popupStore,
  applicationStore,
} from '@pascal/pascal-core';
import { useCallback } from 'react';
import { candiesByIndex, TranslationKeys } from '../../../enums';
import { uuid } from '../../../helpers';
import checkIcon from '../../../assets/images/core/pf-check.png';

export const BetHistoryItem = observer(({ bet }) => {
  const t = useTranslation();
  const { detectAndOpenCheckHashPopup } = popupStore;
  const { isDemo } = applicationStore;

  const openCheckHash = useCallback(
    ({ currentTarget }) => {
      if (!isDemo) {
        const selectedId = +currentTarget.getAttribute('name');
        detectAndOpenCheckHashPopup({
          selectedId,
          name: PopupTypes.CheckHash,
          isFromBetHistory: true,
        });
      }
    },
    [detectAndOpenCheckHashPopup, isDemo]
  );

  return (
    <>
      {
        // !isDemo ? (
        (bet?.additionalParams || bet?.betData).map((el, i) => (
          <ListItemCont key={isDemo ? uuid() : i}>
            <ListItemBox haveHover={!isDemo} name={bet.id} onClick={openCheckHash}>
              <ListItemBoxHeader>
                <ListItemBoxCell size={'big'}>
                  <ListItemBoxText
                    size={'big'}
                    text={`${t(TranslationKeys.RoundId)} ${bet.roundId}`}
                  />
                </ListItemBoxCell>
                <ListItemBoxCell size={'small'}>
                  <ListItemBoxText text={formatDate(bet.date)} size={'big'} />
                </ListItemBoxCell>
                {!isDemo && (
                  <ListItemBoxCell size={'small'}>
                    <ListBoxItemImg imageSrc={checkIcon} />
                  </ListItemBoxCell>
                )}
              </ListItemBoxHeader>
              <ListItemBoxRow>
                <ListItemBoxCell size={'big'}>
                  <ListItemBoxText size={'big'} text={`${t(TranslationKeys.BetType)}`} />
                </ListItemBoxCell>
                <ListItemBoxCell>
                  <ListItemBoxCell size={'small'}>
                    <ListBoxItemImg imageSrc={candiesByIndex[el.candy]} />
                  </ListItemBoxCell>
                  x<ListElemText>{el.odd}</ListElemText>
                </ListItemBoxCell>
              </ListItemBoxRow>
              <ListItemBoxRow>
                <ListItemBoxCell size={'big'}>
                  <ListItemBoxText size={'big'} text={`${t(TranslationKeys.Bet)}`} />
                </ListItemBoxCell>
                <ListItemBoxCell>
                  <ListItemBoxText
                    size={'big'}
                    text={` ${bet.freeBetId ? `${t('FREE_BET')}:` : ''} ${getAmountWithCurrency({
                      amount: convertAmount(el.amount),
                    })}`}
                  />
                </ListItemBoxCell>
              </ListItemBoxRow>
              <ListItemBoxRow>
                <ListItemBoxCell size={'big'}>
                  <ListItemBoxText size={'big'} text={`${t(TranslationKeys.Win)}`} />
                </ListItemBoxCell>
                <ListItemBoxCell>
                  <ListItemBoxText
                    className={'win-color'}
                    size={'big'}
                    text={`${getAmountWithCurrency({ amount: convertAmount(el.winAmount) })}`}
                  />
                </ListItemBoxCell>
              </ListItemBoxRow>
            </ListItemBox>
          </ListItemCont>
        ))
        // ) : (
        //   <ListItemCont key={index}>
        //     <ListItemBox haveHover={!isDemo} name={bet.id} onClick={openCheckHash}>
        //       <ListItemBoxHeader>
        //         <ListItemBoxCell size={'big'}>
        //           <ListItemBoxText
        //             size={'big'}
        //             text={`${t(TranslationKeys.RoundId)} ${bet.roundId}`}
        //           />
        //         </ListItemBoxCell>
        //         <ListItemBoxCell size={'small'}>
        //           <ListItemBoxText text={formatDate(bet.date)} size={'big'} />
        //         </ListItemBoxCell>
        //       </ListItemBoxHeader>
        //       <ListItemBoxRow>
        //         <ListItemBoxCell size={'big'}>
        //           <ListItemBoxText size={'big'} text={`${t(TranslationKeys.BetType)}`} />
        //         </ListItemBoxCell>
        //         <ListItemBoxCell>
        //           <ListItemBoxCell size={'small'}>
        //             <ListBoxItemImg imageSrc={candiesByIndex[bet.candy]} />
        //           </ListItemBoxCell>
        //           x<ListElemText>{bet.odd}</ListElemText>
        //         </ListItemBoxCell>
        //       </ListItemBoxRow>
        //       <ListItemBoxRow>
        //         <ListItemBoxCell size={'big'}>
        //           <ListItemBoxText size={'big'} text={`${t(TranslationKeys.Bet)}`} />
        //         </ListItemBoxCell>
        //         <ListItemBoxCell>
        //           <ListItemBoxText
        //             size={'big'}
        //             text={`${getAmountWithCurrency({
        //               amount: convertAmount(bet.amount),
        //             })}`}
        //           />
        //         </ListItemBoxCell>
        //       </ListItemBoxRow>
        //       <ListItemBoxRow>
        //         <ListItemBoxCell size={'big'}>
        //           <ListItemBoxText size={'big'} text={`${t(TranslationKeys.Win)}`} />
        //         </ListItemBoxCell>
        //         <ListItemBoxCell>
        //           <ListItemBoxText
        //             className={'win-color'}
        //             size={'big'}
        //             text={`${getAmountWithCurrency({ amount: convertAmount(bet.winAmount) })}`}
        //           />
        //         </ListItemBoxCell>
        //       </ListItemBoxRow>
        //     </ListItemBox>
        //   </ListItemCont>
        // )
      }
    </>
  );
});
